import { FC, JSXElementConstructor, ReactElement, useMemo } from 'react'
import {
  Controller,
  ControllerFieldState,
  ControllerRenderProps,
  FieldValues,
  UseFormStateReturn,
  useFormContext,
} from 'react-hook-form'

import { Image, Text } from '@lounge-fe/ui-kit'

import { GiftCardDesignsCarouselProps } from './types'
import { OptionCarousel } from '../OptionCarousel/OptionCarousel'

export const GiftCardDesignsCarousel: FC<GiftCardDesignsCarouselProps> = ({
  name,
  selectedId,
  options: providedOptions,
  variants,
  renderTitle,
  index,
}) => {
  const options = useMemo(
    () =>
      providedOptions
        .map((option) => ({
          id: option,
          name: option,
          image: variants.find(({ options }) => options[index] === option)
            ?.image,
        }))
        .filter(({ image }) => Boolean(image)),
    [providedOptions],
  )

  return (
    <Controller
      render={({
        field,
        fieldState,
      }: {
        field: ControllerRenderProps<FieldValues, string>
        fieldState: ControllerFieldState
        formState: UseFormStateReturn<FieldValues>
      }): ReactElement => (
        <>
          <OptionCarousel
            options={options}
            selectedId={field.value}
            renderTitle={renderTitle}
            renderOption={({ image, id }) => (
              <button
                className="h-full"
                onClick={() => field.onChange(id)}
                type="button"
              >
                <Image
                  className="aspect-[5/7] object-cover object-center w-full h-full"
                  data={{
                    src: image!.src,
                    height: 154,
                    width: 110,
                    crop: 'center',
                  }}
                  alt={image!.alt}
                />
              </button>
            )}
          />
          {fieldState.error?.message && (
            <Text variant="body-sm" className="text-critical">
              {fieldState.error.message}
            </Text>
          )}
        </>
      )}
      name={name}
    />
  )
}
